<template>
  <v-app>
    <div class="animated fadeIn">

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <div id="switchcustomer">
         <v-row>
            <v-col>
               <ddoSelectSwitchCustomer ref="mySelect"
                  @switchCustomer="refresh_page"
               >
               </ddoSelectSwitchCustomer>
            </v-col>
         </v-row>
      </div>

      <b-card>
         <b-tabs>

            <b-tab id="chapter1" active>
               <template slot="title">
                  <big><i class="icon-list"></i> {{ $t('titles.synthesis') }}</big>
               </template>

               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     <v-icon>mdi-chart</v-icon>
                     {{ $t('titles.synthesis') }}
                  </v-card-title>
                  <v-card-text>
                     <ddoClientList :loading="loading" :level="levels[0]" :childKey="levels[0].childKey"
                     :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks" :customSlotNames="levels[0].customSlotNames" ref="mySynthesisList"
                     >
                        <template slot="_create" slot-scope="props">
                           <slot name="_create" v-scope="props">
                              <p>{{ $api._d(props.row._create,'short') }}</p>
                           </slot>
                        </template>

                        <template v-slot:header="slotProps">
                           <span></span>
                        </template>

                        <template slot="c_sms_log_day" slot-scope="props">
                           <span>{{ $api._d(props.row.c_sms_log_day,'fulldaymonth') }}</span>
                        </template>

                        <template slot="status_sent" slot-scope="props">
                           <v-chip v-if="props.row.status_sent>0"
                              color="green"
                           >
                              <strong>{{ props.row.status_sent }}</strong>
                           </v-chip>
                        </template>

                        <template slot="count_submitted" slot-scope="props">
                           <v-chip v-if="props.row.count_submitted>0"
                              color="primary"
                           >
                              <strong>{{ props.row.count_submitted }}</strong>
                           </v-chip>
                        </template>

                        <template slot="status_bounced" slot-scope="props">
                           <v-chip v-if="props.row.status_bounced>0"
                              color="red"
                           >
                              <strong>{{ props.row.status_bounced }}</strong>
                           </v-chip>
                        </template>

                        <template slot="status_graph" slot-scope="props">
                           <ddoGraphPie class="graphcontainer" :ref="buildRef(props.row)" :chartData="PIEchartdata(props.row)" :options="PIEoptions"/>
                        </template>

                        <template v-slot:superheader="slotProps">
                           <h3>{{ $t('subtitles.synthesis_count_sms_per_status_on_last_days') }}</h3>
                           <ddoSelect2
                           :callbacks="PLFcallbacks"
                           :options="PLFoptions"
                           ref="myPLFSelect1"
                           @itemsLoaded="after_refresh_plf"
                           >
                              <template v-slot:selection="data">
                                 <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click:close="$refs.myPLFSelect1.remove(data.item)"
                                 >
                                    <span v-text="data.item.cus_name"></span>
                                 </v-chip>
                              </template>
                              <template v-slot:item="data">
                                 <v-list-item-content>
                                    <v-list-item-title v-html="data.item.cus_name"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.cus_name"></v-list-item-subtitle>
                                 </v-list-item-content>
                              </template>
                           </ddoSelect2><br>
                        </template>
                     </ddoClientList>
                  </v-card-text>
               </v-card>

            </b-tab>

            <b-tab id="chapter2">
               <template slot="title">
                  <big><i class="icon-chart"></i> {{ $t('titles.graphs') }}</big>
               </template>

               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     <v-icon>mdi-chart</v-icon>
                     {{ $t('titles.graphs') }}
                  </v-card-title>
                  <v-card-text>
                     <v-row :hide-default-header="false">
                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile0" :values="charts[0]">
                              <template v-slot:title>
                                 <h4>{{ charts[0].value }}  {{ charts[0].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[0].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine0" key="myGraphLine0" :chartdata="charts[0].chartdata" :options="charts[0].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile1" :values="charts[1]">
                              <template v-slot:title>
                                 <h4>{{ charts[1].value }} {{ charts[1].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[1].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine1" key="myGraphLine1" :chartdata="charts[1].chartdata" :options="charts[1].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile2" :values="charts[2]">
                              <template v-slot:title>
                                 <h4>{{ charts[2].value }} {{ charts[2].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[2].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine2" key="myGraphLine2" :chartdata="charts[2].chartdata" :options="charts[2].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile3" :values="charts[3]">
                              <template v-slot:title>
                                 <h4>{{ charts[3].value }} {{ charts[3].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[3].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine3" key="myGraphLine3" :chartdata="charts[3].chartdata" :options="charts[3].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>
                     </v-row>
                  </v-card-text>
               </v-card>

               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     <v-icon>mdi-chart-line</v-icon>
                     {{ $t('titles.zoom_graph') }}
                     <template>
                        <ddoSelect2
                           :callbacks="GRAPHcallbacks"
                           :options="GRAPHoptions"
                           ref="myGRAPHSelect"
                           @itemsLoaded="after_refresh_plf"
                        >
                           <template v-slot:selection="data">
                              <v-chip
                                 v-bind="data.attrs"
                                 :input-value="data.selected"
                              >
                                 <span v-text="data.item.text"></span>
                              </v-chip>
                           </template>
                           <template v-slot:item="data">
                              <v-list-item-content>
                                 <v-list-item-title v-html="data.item.text"></v-list-item-title>
                              </v-list-item-content>
                           </template>
                        </ddoSelect2>
                     </template>
                     
                      {{ $t('titles.for_account') }}
                     
                     <template>
                        <ddoSelect2
                           :callbacks="ACCOUNTcallbacks"
                           :options="ACCOUNToptions"
                           ref="myACCOUNTSelect"
                           @itemsLoaded="after_refresh_plf"
                        >
                           <template v-slot:selection="data">
                              <v-chip
                                 v-bind="data.attrs"
                                 :input-value="data.selected"
                                 close
                                 @click:close="$refs.myACCOUNTSelect.remove(data.item)"
                              >
                                 <span v-text="data.item.cus_name"></span>
                              </v-chip>
                           </template>
                           <template v-slot:item="data">
                              <v-list-item-content>
                                 <v-list-item-title v-html="data.item.cus_name"></v-list-item-title>
                                 <v-list-item-subtitle v-html="data.item.cus_name"></v-list-item-subtitle>
                              </v-list-item-content>
                           </template>
                        </ddoSelect2>
                     </template>
                  </v-card-title>
                  <v-card-text>
                     <ddoGraphBar v-if="loaded_per_status" ref="myGraphperStatus" :chartdata="charts[4].chartdata" :options="ZOOMoptions" :height="height"/>
                  </v-card-text>
               </v-card>

            </b-tab>
           
            <b-tab id="chapter3">
               <template slot="title">
                  <big><i class="icon-settings"></i> {{ $t('titles.search') }}</big>
               </template>
               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     <v-icon>mdi-search-web</v-icon>
                     {{ $t('titles.search_sms_out') }}
                  </v-card-title>
                  <v-card-text>
                     <v-form v-model="isFormValid">
                        <h3>{{ $t('subtitles.search_criteria') }}</h3>
                        <v-row :hide-default-header="false">

                           <v-col cols="6" sm="6">
                              <h4>{{ $t('subtitles.search_account') }}</h4>
                              <ddoSelect2
                                 :callbacks="PLFcallbacks"
                                 :options="PLFoptions"
                                 ref="myPLFSelect"
                                 @itemsLoaded="after_refresh_plf"
                              >
                                 <template v-slot:selection="data">
                                    <v-chip
                                       v-bind="data.attrs"
                                       :input-value="data.selected"
                                       close
                                       @click:close="$refs.myPLFSelect.remove(data.item)"
                                    >
                                       <span v-text="data.item.cus_name"></span>
                                    </v-chip>
                                 </template>
                                 <template v-slot:item="data">
                                    <v-list-item-content>
                                       <v-list-item-title v-html="data.item.cus_name"></v-list-item-title>
                                       <v-list-item-subtitle v-html="data.item.cus_name"></v-list-item-subtitle>
                                    </v-list-item-content>
                                 </template>
                              </ddoSelect2>
                              <br/><br/>
                              <h4>{{ $t('subtitles.search_status_sms') }}</h4>
                              <ddoSelect2
                                 :callbacks="STATUScallbacks"
                                 :options="STATUSoptions"
                                 ref="mySTATUSSelect"
                              >
                                 <template v-slot:selection="data">
                                    <v-chip
                                       v-bind="data.attrs"
                                       :input-value="data.selected"
                                    >
                                       <span v-text="data.item.status_label"></span>
                                    </v-chip>
                                 </template>
                                 <template v-slot:item="data">
                                    <v-list-item-content>
                                       <v-list-item-title v-html="data.item.status_label"></v-list-item-title>
                                       <v-list-item-subtitle v-html="data.item.status_code"></v-list-item-subtitle>
                                    </v-list-item-content>
                                 </template>
                              </ddoSelect2><br><br>
                           
                           
                              <v-row>
                                 <h4 class="spacetitlerecipient">{{ $t('subtitles.search_recipient') }}</h4>
                                 <VuePhoneNumberInput
                                    v-model="row.phones.phone_mobile.formattedNumber"
                                    :default-country-code="row.phones.phone_mobile.country"
                                    :label="$t('texts.usr_phone_mobile')"
                                    :hint="$t('hints.usr_phone_mobile')"
                                    :translations="translations"
                                    @update="phone_update_mobile"
                                    class="searchresult"
                                 />
                              </v-row><br>
                              <v-row>
                                 <h4 class="spacetitle">{{ $t('subtitles.search_sentfromip') }}</h4>
                                 <v-text-field dense v-model="search_radix_from_sentfromip" maxlength="80" :prefix="$t('texts.search_sent_from_ip')" >
                                 </v-text-field>
                              </v-row><br>
                              <v-row>
                                 <h4 class="spacetitle">{{ $t('subtitles.search_sendingname') }}</h4>
                                 <v-text-field dense v-model="search_radix_from_sendingname" maxlength="80" :prefix="$t('texts.search_start_with')" :label="$t('texts.search_radix_from_sendingname')" >
                                 </v-text-field>
                              </v-row>
                           </v-col>

                           <v-col cols="6" sm="6">
                              <h4>{{ $t('subtitles.search_daterange') }}</h4>
                              {{ $t('subtitles.search_selecteddaterange') }}<v-chip color="default" >{{datesFormatted}}</v-chip><br/>
                              <v-date-picker
                                 v-model="dates"
                                 no-title
                                 :range="true"
                                 :locale="locale"
                                 elevation="15"
                                 @change="change_dates"
                              >
                              </v-date-picker>
                           </v-col>
                        </v-row>
                        
                        <v-btn class="primary" rounded @click="search_sms" :disabled="!isFormValid">{{ $t('buttons.search') }}</v-btn>
                        <br/>
                     </v-form>
                  </v-card-text>
               </v-card>
               <div v-if="searching">
                  <v-card>
                     <v-card-title class="headline grey lighten-1">
                        <v-icon>mdi-search-web</v-icon>
                        {{ $t('subtitles.search_results') }}
                     </v-card-title>
                     <v-card-text>
                        <ddoAlert :errors="search_errors"/> 
                        
                        <v-data-table v-if="search_results.length>0"
                           dense
                           :headers="search_headers"
                           :items="search_results"
                           item-key="_pk"
                           :footer-props="{
                              itemsPerPageOptions: [50,100,200,500,-1]
                           }"
                           
                        >

                           <template v-slot:item.c_sms_log_messageid="{ item }">
                              <v-btn color="primary" class="text-none" rounded @click="search_message(item.c_sms_log_messageid)">{{item.c_sms_log_messageid}}</v-btn>
                              <v-dialog v-model="showMessageDetail" data-app="true" hide-overlay persistent scrollable max-width="60%" elevation="0">
                                 <v-card>
                                    <v-card-title class="headline grey lighten-1">
                                       Message {{search_results[0].c_sms_log_messageid}}
                                       <v-spacer></v-spacer>
                                       <v-icon @click="showMessageDetail=false">mdi-close</v-icon>
                                    </v-card-title>
                                    <v-card-text>
                                       <v-row>
                                          <v-col cols="3">{{ $t('headers.datetime') }}</v-col>
                                          <v-col cols="9">{{search_results[0].d_sms_log_event}}</v-col>
                                       </v-row>
                                       <v-row>
                                          <v-col cols="3">{{ $t('headers.messageid') }}</v-col>
                                          <v-col cols="9">{{search_results[0].c_sms_log_messageid}}</v-col>
                                       </v-row>
                                       <v-row>
                                          <v-col cols="3">{{ $t('headers.recipient') }}</v-col>
                                          <v-col>{{search_results[0].c_sms_log_recipient}}</v-col>
                                       </v-row>
                                       <v-row>
                                          <v-col cols="3">{{ $t('headers.status') }}</v-col>
                                          <v-col cols="9">{{search_results[0].c_sms_log_status}}</v-col>
                                       </v-row>
                                       <v-row>
                                          <v-col cols="3">{{ $t('headers.smsconsumed') }}</v-col>
                                          <v-col cols="9">{{search_results[0].n_sms_log_sms_count}}</v-col>
                                       </v-row>
                                       <v-row>
                                          <v-col cols="3">{{ $t('headers.sendername') }}</v-col>
                                          <v-col cols="9">{{search_results[0].c_sms_log_sendername}}</v-col>
                                       </v-row>
                                       <v-row>
                                          <v-col cols="3">{{ $t('headers.addressrequestip') }}</v-col>
                                          <v-col cols="9">{{search_results[0].c_sms_ipv4}}</v-col>
                                       </v-row>
                                       <v-row>
                                          <v-col cols="3">{{ $t('headers.comments') }}</v-col>
                                          <v-col cols="9">{{search_results[0].comments}}</v-col>
                                       </v-row>
                                    </v-card-text>
                                 </v-card>
                              </v-dialog>
                           </template>
                        </v-data-table>

                     </v-card-text>
                  </v-card>
               </div>
            </b-tab>
         </b-tabs>
      </b-card>

    </div>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import util from 'util';
import BasicComponent from '@/views/BasicComponent.vue';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import TileSimple from '@/components/partials/TileSimple.vue';
import TileSimpleSMSPRO from '@/components/partials/TileSimpleSMSPRO.vue';
import ddoSelectSwitchCustomer from '@/components/ddoSelectSwitchCustomer.vue'
import ddoSelect2 from '@/components/ddoSelect2.vue';
import ddoGraphBar from '@/components/ddoGraphBar.vue';
import ddoGraphPie from '@/components/ddoGraphPie.vue';
import ddoClientList from '@/components/ddoClientList.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
   name: 'customerresellerservicesmspro',

   mixins: [BasicComponent],
   components: {
      ddoAlert,
      ddoWaiting,
      ddoSelectSwitchCustomer, 
      ddoSelect2,
      TileSimple,
      TileSimpleSMSPRO,
      ddoGraphBar,
      ddoGraphPie,
      ddoClientList,
      VuePhoneNumberInput,
   },
   data: () => {
      return {
        translations: {
            countrySelectorLabel: i18n.t('texts.countrySelectorLabel'),
            countrySelectorError: i18n.t('texts.countrySelectorError'),
            phoneNumberLabel: i18n.t('texts.phoneNumberLabel'),
            example: i18n.t('texts.example'),
         },
         accounts : {
            count: null,
            rows: [],
            current_type: null,
            current_data: null,
            current_account: 'null',
            per_status: false,
         },

         row: {
            phones: {
               phone_mobile: {}
            }
         },

         search_recipient: {},

         ws_code: 'service',
         ws_key: 'SMS-PRO-SERVICE',
         ws_stats_keyword: 'stats',
         ws_search_code: 'service_smspro',
         ws_search_keyword: 'search',
         ws_report_type: 'month',

         loading: false,
         searching: false,
         loaded_standard: false,
         loaded_per_status: false,
         height: 250,
         rows: [],
         bgcolors: [],
         charts: [],
         data: [ null, null, null, null ], // month/month_cum, last30day, last12month, per_status
         PIEoptions: {
            responsive: true,
         },
         ZOOMoptions: {
            legend: {
               display: true,
            },
            title: {
               display: false,
               text: ''
            },
            scales: {
               xAxes: [ {
                  display: true,
                  stacked: true,
               }],
               yAxes: [ {
                  display: true,
                  stacked: true,
               }]
            },
            plugins: {
               datalabels: {
                  anchor: 'end',
                  align: 'top',
                  formatter: Math.round,
                  font: {
                     weight: 'bold'
                  }
               }
            }
         },

         showSearchDialog: false,
         showMessageDetail: false,
         current_messageid: null,

         boolFormValid: false,
         search_radix_from: null,
         search_radix_from_sentfromip: null,
         search_radix_from_sendingname: null,
        
         dates: [ new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10) ],

         dropdown_graph_text: i18n.t('texts.choose_dropdown_graph'),
         dropdown_graph_account: i18n.t('texts.choose_dropdown_account'),

         message_results: [],
         message_headers: [
            { text: i18n.t('headers.datetime'), value: 'd_sms_log_event', width: "200px", fixed: true },
            { text: i18n.t('headers.traces'), value: 'c_sms_log_comments' },
         ],

         search_errors: [],
         message_errors: [],

         /* 
         LEVEL 0 : all for ddoClientList : columns, options, callbacks
         */
         levels: [
            {
               api_code: 'service_smspro',
               api_prefix: 'prl',
               row: {},
               level: 0,
               errors: [],
               columns: ['c_sms_log_day', 'count_submitted', 'status_sent', 'status_bounced', 'status_graph' ],
               customSlotNames: ['c_sms_log_day', 'count_submitted', 'status_sent', 'status_bounced', 'status_graph'],
               searchValues: {
               },
               options: {
                  showChildRowToggler: false,
                  hiddenColumns: [],
                  headings: {
                     c_sms_log_day: i18n.t('headers.synthesis_date'),
                     count_submitted: i18n.t('headers.count_submitted'),
                     status_sent: i18n.t('headers.synthesis_sent'),
                     status_bounced: i18n.t('headers.synthesis_bounced'),
                     status_graph: i18n.t('headers.synthesis_graph'),
                  },
                  texts: {
                  },
                  uniqueKey: 'prl_pk',
                  sortable: ['cus_code','_update'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                  columnsDropdown: false,
                  pagination: {
                     chunk: 5,
                     edge: false,
                     nav: 'scroll'
                  },
                  columnsDisplay: {
                     _update: 'desktop',
                     cus_code: 'desktop',
                     cus_pk: 'desktop',
                  },
                  customFilters: [{
                     name: 'search',
                     callback: function (row, query) {
                        let $ret = true;
                        return $ret;
                     }
                  }],
               },
               callbacks: {
               },
               dialogOptions: {
                  codeRules : [
                     (v) => !!v || i18n.t('texts._required')
                  ]
               },
               dialogValues: {
                  headers: {
                     select: i18n.t('texts.cus_select_title'),
                     create: i18n.t('texts.cus_create_title'),
                     update: i18n.t('texts.cus_update_title'),
                     delete: i18n.t('texts.cus_delete_title'),
                  },
                  texts: {
                     create_item: i18n.t('texts.cus_create_item'),
                  },
                  dialogShow: false,
                  form_disabled: false,
                  form_close: true,
                  form_create: false,
                  form_update: false,
                  form_delete: false,
                  readonly: false,
                  header_value_function: function(row) { return row['cus_code']; }
               },
            },
         ],

         PLFcallbacks: {},
         PLFoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            rules: [
               (v) => !!v || i18n.t('texts._required')
            ],
            item_text: "cus_name",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
         },

         STATUScallbacks: {},
         STATUSoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "status_label",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
         },

         ACCOUNTcallbacks: {},
         ACCOUNToptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "status_label",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
         },

         GRAPHcallbacks: {},
         GRAPHoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "value",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
         },

         dropdown_graph_text: i18n.t('texts.choose_dropdown_graph'),
         dropdown_graph_account: i18n.t('texts.choose_dropdown_account'),
         search_results: [],
         search_headers: [
            { text: i18n.t('headers.datetime'), value: 'd_sms_log_event' },
            { text: i18n.t('headers.messageid'), value: 'c_sms_log_messageid' },
            { text: i18n.t('headers.recipient'), value: 'c_sms_log_recipient' },
            { text: i18n.t('headers.status'), value: 'c_sms_log_status' },
            { text: i18n.t('headers.smsconsumed'), value: 'n_sms_log_sms_count' },
            { text: i18n.t('headers.sendername'), value: 'c_sms_log_sendername' },
            { text: i18n.t('headers.addressrequestip'), value:'c_sms_log_sender_ipaddress.address' },
            { text: i18n.t('headers.comments'), value: 'comments' },
         ],

         locale: null,

         options: [],
         data_type: 'sms',

         current_unit: ' ?',
   
      }
   },

   created() {
      
      this._this = this;
      var empty_chart = { value: null, unit: '', total_sms: 0, message: '', labels: [], severity: [], date: [], data: [], reference: [], chartdata: { labels: [], datasets: [] }, options: {} };

      for( var i=0;i<=4;i++ ) {
         this.charts.push( JSON.parse(JSON.stringify(empty_chart)) );
      }

      this.levels[0].callbacks.refresh_rows   = this.refresh_rows_l1;

      var style = getComputedStyle(document.body);

      this.row.phones.phone_mobile = { formattedNumber: '' };

   },

   async mounted() {
      var style = getComputedStyle(document.body);
      this.bgcolors[0] = style.getPropertyValue('--success');
      this.bgcolors[1] = style.getPropertyValue('--warning');
      this.bgcolors[2] = style.getPropertyValue('--danger');
      this.bgcolors[3] = style.getPropertyValue('--secondary');

      this.PLFcallbacks.refresh_rows = this.build_select_plf;
      this.PLFcallbacks.change       = this.change_plf;
      
      this.GRAPHcallbacks.refresh_rows = this.build_select_graphtype;
      this.GRAPHcallbacks.change       = this.change_graphtype;
     
      this.STATUScallbacks.refresh_rows  = this.build_select_status;
     
      this.ACCOUNTcallbacks.refresh_rows = this.build_select_plf;
      this.ACCOUNTcallbacks.change       = this.change_plf;
      
      await this.refresh_page();
      this.locale = navigator.language;  
    },

   computed: {
      datesFormatted () {
         if ( Array.isArray(this.dates) ) {
            if ( this.dates.length==2 && this.dates[0]>this.dates[1] ) {
               let tmp = this.dates[0];
               this.dates[0] = this.dates[1];
               this.dates[1] = tmp;
            }
            return this.dates.join(' ~ ')
         } else {
            return this.dates
         }
      },
      isFormValid: {
         get: function() {
            return this.boolFormValid;
         },
         set: function(newValue) {
            this.boolFormValid = newValue;
         }
      },
      
   },

   methods: {

      zero_if_null(value) {
         if ( value==null ) {
            return 0
         } else {
            return value
         }
      },

      buildRef(row) {
         return '_pie_graph_'+row._pk;
      },

      PIEchartdata(row) {
         if ( row.c_sms_log_day  ) {
            return {
               datasets: [
                  {
                     backgroundColor: [ 'green', 'red' ],
                     data: [ this.zero_if_null(row.status_sent), this.zero_if_null(row.status_bounced) ]
                  },
               ]
            }
         } else {
            return { datasets: [] }
         }
      },

      async refresh_rows_l1(key) {
         var row_plf = this.$api._get_by_pk(this.$refs.myPLFSelect1.items,this.PLFoptions.selected);
         var day_to   = new Date().toISOString().substr(0, 10);
         var day_from   = new Date( Date.now() - 1000 * 86400 * 8 ).toISOString().substr(0, 10);
         if ( row_plf!=null ) {
            let parameters = { log_cus_pk: row_plf.cus_pk, log_day_from: day_from, log_day_to: day_to, log_count_per_day: true };
            this.loading = true;
            let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_search_keyword, parameters ); 
            this.loading = false;        
            return { errorinfos, api_response }
         } else {
            return { errorinfos : null, api_response: {error: 0, rows: []} }
         }
      },

      async openSearchDialog() {
         if ( this.$refs.myPLFSelect ) {
            await this.$refs.myPLFSelect.refresh_rows();
         }
         this.search_errors = [];
         this.search_results = [];
         this.showSearchDialog = true;
      },

      async change_dates(value,item=null) {
         if ( value!=null ) {
            await this.$refs.mySTATUSSelect.refresh_rows();
         }
      },

      LightenDarkenColor(col,amt) {
         col = col.trim();
         var usePound = false;
         if ( col.substring(0,1) == "#" ) {
            col = col.substring(1);
            usePound = true;
         }
         var num = parseInt(col,16);
         var r = (num >> 16) + amt;

         if ( r > 255 ) r = 255;
         else if  (r < 0) r = 0;

         var b = ((num >> 8) & 0x00FF) + amt;

         if ( b > 255 ) b = 255;
         else if  (b < 0) b = 0;

         var g = (num & 0x0000FF) + amt;

         if ( g > 255 ) g = 255;
         else if  ( g < 0 ) g = 0;

         return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
      },

      get_max(data,_min=0) {
         var _max = _min;
         for( var i=0;i<data.length;i++ ) {
            if ( data[i]>_max ) { _max = data[i]; }
         }
         return _max;
      },

      compute_currentmonth(data) {
         if (data[0] && data[0].prl_day) {
            var _date = new Date(data[0].prl_day);
         } else {
            var _date = new Date(data[0].prl_day);
         }
         var _month = _date.getMonth();
         return _month;
      },

      build_labels(report_type,data,length) {
         var labels = [];
         var _format = 'short';
         if ( report_type=='last12months' ) {
            _format = 'monthly';
         }
         for (var i=0;i<data.length;i++) {
            labels.push( this.$api._d(data[i],_format) );
         }
         if ( labels.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=labels.length;i<length;i++) {
               labels.push( '' );
            }
         }
         return labels;
      },

      build_bgcolors(report_type,data,length) {
         var bgcolors = [];
         for (var i=0;i<data.length;i++) {
            bgcolors.push( this.bgcolors[data[i]] );
         }
         if ( bgcolors.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_bgcolors_v2(report_type,data,length,percent) {
         var bgcolors = [];
         for (var i=0;i<data.length;i++) {
            bgcolors.push( this.LightenDarkenColor(this.bgcolors[data[i]], percent) );
         }
         if ( bgcolors.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_bgcolors_per_status(report_type,data,length,percent) {
         var bgcolors = [];
         for (var i=0;i<data.length;i++) {
            bgcolors.push( this.LightenDarkenColor(this.bgcolors[this.bgcolors.length-1], percent) );
         }
         if ( bgcolors.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_options_standard(data) {
         var options = {
            legend: {
               display: false,
            },
            scales: {
               xAxes: [ {
                  display: false,
               }],
               yAxes: [ {
                  display: false,
                  ticks: {
                     min: 0,
                     max: this.get_max(data),
                  }
               }]
            }
         };
         return options;
      },

      build_options(report_type,data) {
         var options = {
            legend: {
               display: false,
            },
            scales: {
               xAxes: [ {
                  display: false,
                  stacked: true,
               }],
               yAxes: [ {
                  display: false,
                  stacked: true,
                  ticks: {
                     min: 0,
                     max: this.get_max(data),
                  }
               }]
            }
         };
         return options;
      },

      build_accounts_list(rows) {
         this.accounts.count = rows.length;
         this.accounts.rows = [];
         if ( this.accounts.count>1 ) {
            this.accounts.rows.push( { _pk: -1, code: 'null', name: '*' } );
         }
         for (var j=0;j<rows.length;j++) {
            this.accounts.rows.push( { _pk: j, code: rows[j].prl_sub_key_1, name: rows[j].prl_sub_key_1 } );
         }
      },

      prepare_chart_data_standard(values,rows,report_type,data_type) {
         values.date = [];
         values.severity = [];
         values.data = [];
         values.total_sms = 0;
        
         var current_date = new Date();
         current_date = current_date.toISOString().substr(0,10);

         for ( var i=0; i<rows.length; i++ ) {

            if (rows[i].prl_day<=current_date) {
               values.total_sms = values.total_sms+parseInt(rows[i].prl_count1);
               values.date.push(rows[i].prl_day);
               values.severity.push(rows[i].esv_severity);
            }

            switch ( report_type ) {
               case 'month_cum' : {
                  switch( data_type ) {
                     case 'sms' : {
                        if ( i > 0 && rows[i].prl_day<=current_date ) {
                           values.data.push(parseInt(rows[i].prl_count1)+values.data[values.data.length-1])
                        } else {
                           values.data.push(parseInt(rows[i].prl_count1))
                        }
                        break;
                     }
                  }
                  break;
               }
               default : {
                  switch( data_type ) {
                     case 'sms' : {
                        values.data.push(parseInt(rows[i].prl_count1))
                        break;
                     }
                  }
               }
            } 
         } 

         var dataset_label = '';

         switch ( data_type ) {

            case 'sms':
               values.value = values.total_sms;
               values.unit = i18n.t('texts._sms').toLowerCase();
               switch( report_type ) {
                  case 'month'        : values.message = i18n.t('texts.smspro_sms_month_short'); break;
                  case 'month_cum'    : values.message = i18n.t('texts.smspro_sms_month_cumulative_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.smspro_sms_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.smspro_sms_last12months_short'); break;
               }
               break;

         }

         if ( this.accounts.current_account && this.accounts.current_account!='null' ) {
            dataset_label  = dataset_label + ' (' + this.accounts.current_account + ')';
         }

         var _nb_of_rows = 31;
         if ( report_type=='last12months') {
            _nb_of_rows = 12;
         }

         values.values = values.data;
         values.options = this.build_options_standard(values.data);
         values.chartdata = {
            labels : this.build_labels(report_type,values.date,_nb_of_rows),
            datasets: [
               {
                  label: 'total',
                  backgroundColor: this.build_bgcolors(report_type,values.severity,_nb_of_rows),
                  data: values.data
               },
            ]
         };
         
      },

      prepare_chart_data_per_status( values, rows, report_type, data_type ) {
         //var values = { value: 0, unit: '', total_bytes: 0, total_sms: 0, message: '', labels: [], severity: [], date: [], data1: [], data2: [], data1cum: [], data2cum: [], reference: [] }
         var statuses = [ 'sent', 'bounced' ];

         values.date = [];
         values.severity = [];
         values.data = [];
         values.total_sms = 0;

         var _nb_of_rows = 31;
         if ( report_type == 'last12months') {
            _nb_of_rows = 12;
         }

         values.chartdata = {
            datasets: [
               { label: i18n.t('texts.smspro_sms_sent')    , backgroundColor: '', borderColor: '#000000', borderWidth: 1, borderStyle: 'solid', data: [] }, 
               { label: i18n.t('texts.smspro_sms_bounced') , backgroundColor: '', borderColor: '#000000', borderWidth: 1, borderStyle: 'solid', data: [] }
            ]
         };

         for ( var i=0; i<rows.length; i++ ) {

            // Pre-fill values[...][0], for month_cum
            if ( i==0 ) {
               for ( var k=0;k<statuses.length;k++ ) {
                  values.chartdata.datasets[k].data[i] = 0;
               }
            }

            values.total_sms = values.total_sms+parseInt(rows[i].prl_count1);
            values.date.push(rows[i].prl_day);
            values.severity.push(rows[i].esv_severity);

            let key1 = null;
            let key2 = null;
            let keys = null;
            keys = Object.keys(rows[i]['prl_values']);
            for ( var k=0;k<keys.length;k++ ) {
               key1 = keys[k];
               key2 = key1;
               // key1 ; original key value
               // key2 : copy of key1, except when key1='total' and 'no_detail'; if this case => key2 = 'sent'
               if ( rows[i]['prl_no_detail'] && rows[i]['prl_no_detail']==true && key1=='total' ) {
                  key2 = 'sent';
               }
               if ( statuses.indexOf(key2)>=0 ) {
                  switch (report_type) {
                     case 'month_cum':
                        switch( data_type ) {
                           case 'sms' :
                              if ( i>0 ) {
                                 values.chartdata.datasets[statuses.indexOf(key2)].data[i] = parseInt(rows[i]['prl_values'][key1].prl_count1) + values.chartdata.datasets[statuses.indexOf(key2)].data[i-1];
                              } else {
                                 values.chartdata.datasets[statuses.indexOf(key2)].data[i] = parseInt(rows[i]['prl_values'][key1].prl_count1);
                              }
                              break;
                        }
                        break;
                     default:
                        switch( data_type ) {
                           case 'sms' :
                              values.chartdata.datasets[statuses.indexOf(key2)].data[i] = parseInt(rows[i]['prl_values'][key1].prl_count1);
                              break;
                        }
                        break;
                  }
               }
            }

         }
         
         values.chartdata.datasets[statuses.indexOf('sent')   ].backgroundColor = this.build_bgcolors_per_status('month',values.severity,31,0);
         values.chartdata.datasets[statuses.indexOf('bounced')].backgroundColor = this.build_bgcolors_per_status('month',values.severity,31,-20);

         var dataset_label = '';

         switch ( data_type ) {

            case 'sms':
               values.value = values.total_sms;
               values.unit = i18n.t('texts._sms').toLowerCase();
               switch( report_type ) {
                  case 'month'        : values.message = i18n.t('texts.smspro_sms_month_short'); break;
                  case 'month_cum'    : values.message = i18n.t('texts.smspro_sms_month_cumulative_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.smspro_sms_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.smspro_sms_last12months_short'); break;
               }
               break;

         }

         if ( this.accounts.current_account && this.accounts.current_account!='null' ) {
            dataset_label  = dataset_label + ' (' + this.accounts.current_account + ')';
         }

         values.values = values.data;
         values.chartdata.labels = this.build_labels(report_type,values.date,_nb_of_rows);

         // Adapt title :
         this.ZOOMoptions.title.display = true;
         this.ZOOMoptions.title.text = values.unit+" "+values.message;
      },

      retrieve_row_by_date(rows,date,lastindex) {
         for ( var j=lastindex;j<rows.length;j++) {
            if (rows[j].prl_day && rows[j].prl_day==date) {
               return j;
            }
         }
         return null;
      },

      restructure_monthly_records(report_type,rows) {
         var current_date = new Date();
         var empty_row = { prl_major_key: null, prl_day: null, prl_count0: 0, prl_count1: 0, prl_count2: 0, esv_severity:0 }
         var restructured_rows = [];
         var lastindex = 0;
         var currentindex = 0;
         switch ( report_type ) {
            case 'month':
            case 'month_cum':
               var start_date = current_date;
               start_date.setDate(1);
               for ( var i=0;i<31;i++) {
                  let current_row = JSON.parse(JSON.stringify(empty_row));
                  currentindex = this.retrieve_row_by_date(rows,start_date.toISOString().substr(0, 10),lastindex);
                  if ( currentindex!=null ) { current_row = rows[currentindex]; }
                  restructured_rows.push(JSON.parse(JSON.stringify(current_row)));
                  start_date.setDate(start_date.getDate()+1);
               }
               return restructured_rows;
               break;
            case 'last30':
               var start_date = current_date;
               start_date.setDate(start_date.getDate()-30);
               for ( var i=0;i<31;i++) {
                  let current_row = JSON.parse(JSON.stringify(empty_row));
                  currentindex = this.retrieve_row_by_date(rows,start_date.toISOString().substr(0, 10),lastindex);
                  if ( currentindex!=null ) { current_row = rows[currentindex]; }
                  restructured_rows.push(JSON.parse(JSON.stringify(current_row)));
                  start_date.setDate(start_date.getDate()+1);
               }
               return restructured_rows;
               break;
            default:
               return rows;
               break;
         }
      },

      async refresh_data_standard(report_type,force_all=false) {
         let parameters = { plf_report_type: report_type, plf_per_status: false };
         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_stats_keyword, parameters );
         if ( api_response.error==0 ) {
            return this.restructure_monthly_records(report_type,api_response.rows);
         } else {
            return null;
         }
      },

      async refresh_data_per_status(report_type,force_all=false) {
         let parameters = { plf_report_type: report_type, plf_per_status: true };
         if ( this.ACCOUNToptions.selected!=null) {
            let row_account = this.$api._get_by_pk(this.$refs.myACCOUNTSelect.items,this.ACCOUNToptions.selected);
            parameters.plf_report_account = row_account.cus_pk;
         }
         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_stats_keyword, parameters );
         if ( api_response.error==0 ) {
            return api_response.rows;
         } else {
            return null;
         }
      },

      async refresh_accounts() {
         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/accounts' );
         if ( api_response.error==0 ) {
            this.build_accounts_list(api_response.rows);
         }
      },

      async refresh_data() {

         this.loaded_standard = false;
         this.loaded_per_status = false;

         await this.refresh_accounts();
         this.data[0] = await this.refresh_data_standard( 'month' );
         this.data[1] = await this.refresh_data_standard( 'month_cum' );
         this.data[2] = await this.refresh_data_standard( 'last30' );
         this.data[3] = await this.refresh_data_standard( 'last12months' );
         this.prepare_chart_data_standard( this.charts[0],this.data[0],'month','sms',false );
         this.prepare_chart_data_standard( this.charts[1],this.data[1],'month_cum','sms',false );
         this.prepare_chart_data_standard( this.charts[2],this.data[2],'last30','sms',false );
         this.prepare_chart_data_standard( this.charts[3],this.data[3],'last12months','sms',false );
         
         this.data[4] = await this.refresh_data_per_status( 'month' );
         this.prepare_chart_data_per_status( this.charts[4],this.data[4],'month','sms' );

         this.loaded_standard = true;
         this.loaded_per_status = true;
         
      },

      refresh_pie_graphs() {
         let keys = Object.keys(this.$refs);
         for (var i=0;i<keys.length;i++) {
            if ( keys[i].indexOf('_pie_graph_')==0 ) {
               this.$refs[keys[i]].update();
            }
         }
      },

      async refresh_page() { 
         // Refresh dropdowns :
         await this.$refs.myPLFSelect.refresh_rows();      // chapter3 / search engine
         await this.$refs.myPLFSelect1.refresh_rows();     // chapter1 / synthesis
         await this.$refs.mySTATUSSelect.refresh_rows();   // chapter2 / graphs
         await this.$refs.myGRAPHSelect.refresh_rows();
         await this.$refs.myACCOUNTSelect.refresh_rows();  // chapter2 / account
                  
         // items from dropdowns stat with a _pk = 1
         this.PLFoptions.selected = null;
         if ( this.$refs.myPLFSelect1.items.length>=1 ) {
            this.PLFoptions.selected = this.$refs.myPLFSelect1.items[0]._pk;
         }
         this.ACCOUNToptions.selected = null;
         if ( this.$refs.myACCOUNTSelect.items.length>=1 ) {
            this.ACCOUNToptions.selected = this.$refs.myACCOUNTSelect.items[0]._pk;
         }
         this.GRAPHoptions.selected = null;
         if ( this.$refs.myGRAPHSelect.items.length>=1 ) {
            this.GRAPHoptions.selected = this.$refs.myGRAPHSelect.items[0]._pk;
         }

         // Refresh Synthesis List :
         await this.$refs.mySynthesisList.refresh_rows();  // chapter1 / list

         await this.refresh_data();

         this.refresh_pie_graphs();
        
      },

      async switch_type(report_type,data_type,account_name='null') {
         
         this.loaded_per_status = false;
         this.data[4] = await this.refresh_data_per_status( report_type );
         this.prepare_chart_data_per_status( this.charts[4],this.data[4],report_type,data_type );
         this.loaded_per_status = true;
      },

      async build_select_plf(key=null) {
         this.$refs.myPLFSelect.selected = null;
         this.$refs.myPLFSelect1.selected = null;
         this.$refs.myACCOUNTSelect.selected = null;
         this.$refs.myGRAPHSelect.selected = null;

         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customerreseller/smsplatforms');
         this.loading = false;
         if ( api_response.error==0 ) {
            var restructured_rows = [];
            // _pk is a manually managed counter, to be used as primary key in ddoSelect(2) arrays
            var _pk = 1;
            for ( var i=0;i<api_response.rows.length;i++) {
               api_response.rows[i]._pk = api_response.rows[i].cus_plf_pk;
               let codes = api_response.rows[i].cus_name.split(',');
               if (codes.length==1 ) {
                  api_response.rows[i]._pk = _pk;
                  restructured_rows.push(api_response.rows[i]);
                  _pk++;
               } else {
                  for ( var j=0;j<codes.length;j++) {
                     api_response.rows[i].cus_name = codes[j];
                     api_response.rows[i]._pk = _pk;
                     _pk++;
                     restructured_rows.push(JSON.parse(JSON.stringify(api_response.rows[i])));
                  }
               }
            }
            restructured_rows.sort(function(a,b) { if (a.cus_name<b.cus_name) { return -1; } if (a.cus_name>b.cus_name) { return 1; } return 0; } );
            api_response.rows = restructured_rows;
         }
         return { errorinfos, api_response }
      },

      async build_select_graphtype(key=null) {
         this.$refs.myGRAPHSelect.selected = null;
         var errorinfos = null;
         var api_response = {
            error: 0,
            rows: [
               { _pk: 1, value: 'month,sms', text: i18n.t('texts.smspro_sms_month')     },
               { _pk: 2, value: 'month_cum,sms', text: i18n.t('texts.smspro_sms_month_cumulative')     },
               { _pk: 3, value: 'last30,sms', text: i18n.t('texts.smspro_sms_last30')     },
               { _pk: 4, value: 'last12months,sms', text: i18n.t('texts.smspro_sms_last12months')     },
               
            ]
         }
         return { errorinfos, api_response }
      },

      async build_select_status(key=null) {
         this.$refs.mySTATUSSelect.selected = null;
         var errorinfos = null;
         var api_response = {
            error: 0,
            rows: [
               { _pk: 'sent'    , 'status_code': 'sent'    , 'status_label': i18n.t('texts.smspro_sms_sent')     },
               { _pk: 'bounced' , 'status_code': 'bounced' , 'status_label': i18n.t('texts.smspro_sms_bounced')  },
            ]
         }        
         return { errorinfos, api_response }
         
      },

      after_refresh_plf(items) {
         if ( this.$refs.myPLFSelect.selected==null && items.length>=1 ) {
            this.$refs.myPLFSelect.selected = items[0]._pk;
         }
         if ( this.$refs.myPLFSelect1.selected==null && items.length>=1 ) {
            this.$refs.myPLFSelect1.selected = items[0]._pk;
         } 
         if ( this.$refs.myGRAPHSelect.selected==null && items.length>=1 ) {
            this.$refs.myGRAPHSelect.selected = items[0]._pk;
         } 
         if ( this.$refs.myACCOUNTSelect.selected==null && items.length>=1 ) {
            this.$refs.myACCOUNTSelect.selected = items[0]._pk;
         } 
      },

      async change_plf(value,item=null) {
         this.PLFoptions.selected = value;
         this.ACCOUNToptions.selected = value;
         this.$refs.mySynthesisList.refresh_rows();
         this.change_graphtype(this.GRAPHoptions.selected);
      },

      change_graphtype(value,item=null) {
         this.GRAPHoptions.selected = value;
         let row_graph = this.$api._get_by_pk(this.$refs.myGRAPHSelect.items,value);
         let account_pk = this.ACCOUNToptions.selected;
         let row_account = this.$api._get_by_pk(this.$refs.myACCOUNTSelect.items,account_pk);
         if ( row_graph!=null && row_account!=null ) {
            let values = row_graph.value.split(',');
            if ( values.length==2 ) {
               this.switch_type(values[0],values[1],row_account.cus_pk);
            }
         }
      },

     build_comments(row,clean=false) {
         var ret = '';
         
         var recipient = '';
         if ( row.c_sms_log_radix ) {
            recipient = row.c_sms_log_radix;
         }
         var status='';
         if ( row.c_sms_log_status_send ) {
            switch (row.c_sms_log_status_send) {
               case 'sent' : status = i18n.t('texts.search_results_hasbeendelivered'); break;
               case 'bounced' : status = i18n.t('texts.search_results_hasbeenrejected'); break;
            }
         }
         if ( clean==true ) {
            ret = util.format(i18n.t('texts.search_results_comments_clean'),sender,recipient,status);
         } else {
            ret = util.format(i18n.t('texts.search_results_comments'),sender,recipient,status);
         }
         return ret;
      },


       phone_update_mobile(data) {
         if ( data.isValid ) {
            this.search_recipient = data;
         }
      },

      async search_sms() {
         if ( this.PLFoptions.selected>0 ) {
            this.searching = true;
            this.search_errors = [];
            this.search_results = [];
            this.message_errors = [];
            var row_plf = this.$api._get_by_pk(this.$refs.myPLFSelect.items,this.PLFoptions.selected);
            var parameters = { log_cus_pk: row_plf.cus_pk, }
            if ( Array.isArray(this.dates) ) {
               parameters.log_day_from = this.dates[0];
               if ( this.dates[1] && this.dates[0]!=this.dates[1] ) { parameters.log_day_to = this.dates[1]; }
            } else {
               parameters.log_day_from = this.dates;
            }
            if ( this.STATUSoptions.selected!=null ) { parameters.log_status = this.STATUSoptions.selected; }
            if ( this.search_recipient.isValid && this.search_recipient.formattedNumber.length>0 ) { parameters.log_recipient = this.search_recipient.formattedNumber; }
            if ( this.search_radix_from_sentfromip && this.search_radix_from_sentfromip.length>0) { parameters.log_sender_ipaddress = this.search_radix_from_sentfromip; }
            if ( this.search_radix_from_sendingname && this.search_radix_from_sendingname.length>0) { parameters.log_sendername = this.search_radix_from_sendingname; }

            this.loading = true;
            let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_search_keyword, parameters );
            this.loading = false;
            if ( api_response.error==0 ) {
               for ( var i=0;i<api_response.rows.length;i++) {
                  api_response.rows[i]._pk = i+1;
                  let _date = new Date(api_response.rows[i].d_sms_log_submission.seconds*1000);
                  api_response.rows[i].d_sms_log_event_iso = _date.toISOString().replace('T',' ').substring(0,19);
                  api_response.rows[i].d_sms_log_event     = this.$api._d(_date.toISOString(),'timestamp1');
                 
                  api_response.rows[i].c_sms_log_recipient = api_response.rows[i].c_sms_log_recipient;
                  api_response.rows[i].c_sms_log_status = api_response.rows[i].c_sms_log_status;
                  api_response.rows[i].n_sms_log_sms_count = api_response.rows[i].n_sms_log_sms_count;
                  api_response.rows[i].c_sms_log_sendername = api_response.rows[i].c_sms_log_sendername;
                  api_response.rows[i].c_sms_log_sender_ipaddress = api_response.rows[i].c_sms_log_sender_ipaddress;
                  api_response.rows[i].comments            = 'commentaires en dur'; 
                  //api_response.rows[i].comments            = this.build_comments(api_response.rows[i]); 
                  
               }
            } else {
            }
            this.search_errors = [ errorinfos ];
            this.search_results = api_response.rows;
         }
      },

      async search_message(messageid) {
         if ( this.PLFoptions.selected>0 ) {
            this.message_errors = [];
            var parameters = { log_messageid: messageid };
            this.loading = true;
            let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_search_keyword, parameters );
            this.loading = false;
            if ( api_response.error==0 ) {
               if ( api_response.rows.length>0 ) {
                  let _date = new Date(api_response.rows[0].d_sms_log_submission.seconds*1000);
                  api_response.rows[0].d_sms_log_event = this.$api._d(_date.toISOString(),'timestamp1');
                  api_response.rows[0].c_sms_ipv4 = null;
                  if (api_response.rows[0].c_sms_log_ipaddress !=null ) {
                     api_response.rows[0].c_sms_ipv4 = api_response.rows[0].c_sms_log_ipaddress.address;
                  } 
               }
               this.message_results = api_response.rows[0];
            } else {
               this.message_errors = [ errorinfos ];
            }
         }
         this.current_messageid = messageid;
         this.showMessageDetail = true;
      },

   }
}
</script>

<style>

.mark, mark {
    padding: .2em;
    background-color: yellow;
}
.graphcontainer {
   width: 50px;
   max-width: 50px;
   height: 50px;
   max-height: 50px;
   margin-left: auto;
   margin-right: auto;
}

.searchresult {
   margin-bottom: 10px;
}

.spacetitlerecipient {
   margin-right: 20px;
   margin-top: 10px
}

.spacetitle {
   margin-right: 20px
}

</style>